import { environment } from '../consts/environment'

/**
 * Returns a clean domain by removing the 'www.' prefix and appending the port number if in development environment.
 *
 * @param domain - The domain to clean.
 * @returns The cleaned domain.
 */
export const getCleanDomain = (domain: string): string => {
  const cleanDomain = domain.split('www.')[1] || domain
  return cleanDomain + (environment.env === 'development' ? ':3000' : '')
}

/**
 * Extracts the hostname from a given URL.
 *
 * @param url - The URL from which to extract the hostname.
 * @returns The extracted hostname or the original URL if an error occurs.
 */
export const getHostName = (url: string): string => {
  try {
    return getCleanDomain(new URL(url).hostname)
  } catch (error) {
    return url
  }
}

/**
 * Returns a safe URL by adding 'http://' prefix if it is missing.
 *
 * @param url - The URL to be made safe.
 * @returns The safe URL.
 */
export const getLinkSafeUrl = (url: string): string =>
  url && url.includes('http') ? url : `http://${url}`

// Validate if is a valid URL and if environment is prod allow only https
export const isUrlValid = (url: string): boolean => {
  const isProd = environment.env === 'production'
  const isHttps = url.includes('https://')
  const isHttp = url.includes('http://')
  return isProd ? isHttps : isHttps || isHttp
}